import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonsModule } from '../button/button.module';
import {
  ModalComponent,
  ModalContentComponent,
  ModalFooterComponent,
  ModalHeaderComponent
} from './modal.component';
import { ModalService } from './modal.service';
import { ModalSharedService } from './modal.sharedService';
import { IconModule } from './../icon/icon.module';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    IconModule
  ],
  declarations: [
    ModalComponent,
    ModalHeaderComponent,
    ModalContentComponent,
    ModalFooterComponent
  ],
  exports: [
    ModalComponent,
    ModalHeaderComponent,
    ModalContentComponent,
    ModalFooterComponent
  ],
  providers: [
    ModalService,
    ModalSharedService
  ]
})
export class ModalModule { }
